import React from 'react'

const AdminSidebar = ({ ...props }) => {
  return (
    <div className="aside-layout">
      { props.children }
    </div>
  )
}

export default AdminSidebar